import { inject, Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { UseraccountModel } from '../models';
import { SseService } from './sse.service';
import { StorageService } from './storage.service';
import { Subject } from 'rxjs';
import { RbacService } from './rbac.service';
import { Router } from '@angular/router';
import { ShoppingInfoStore } from '../stores';
import { APPCONSTANT } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private shoppingStore = inject(ShoppingInfoStore);
  private storageService = inject(StorageService);
  private sseService = inject(SseService);
  private rbacService = inject(RbacService);
  private router: Router = inject(Router);
  public googleRoleErr$: Subject<string> = new Subject<string>();
  public isLoggedIn(): boolean {
    const jwt = this.storageService.getJWT();
    if (jwt) {
      return true;
    }
    return false;
  }

  public logOut(): void {
    const jwt = this.storageService.getJWT();
    if (jwt) {
      this.rbacService.logout().subscribe((user) => {
        console.log('=== ammall logged out ===');
        this.sseService.abortSSE();
        this.storageService.removeJWT();
        this.storageService.removeLocalItem(APPCONSTANT.BUYER_INFO);
        this.storageService.removeLocalItem('avatar');
        this.shoppingStore.clearAll();
        this.router.navigate(['home', { outlets: { mainBody: null } }]);
      });
    }
  }

  public getLogginedUser(): UseraccountModel {
    return this.storageService.getLocalItem(APPCONSTANT.BUYER_INFO) as UseraccountModel;
  }
}
